export const ExperimentsKeys = {
    pwaNativeSplitVariation: 'mg_split_native_vs_pwa',
    mg_add_plan_upgrade_screen: 'mg_add_plan_upgrade_screen',
    mg_highlighted_block_paywall_page: 'mg_highlighted_block_paywall_page',
    mg_personal_statement_screens: 'mg_personal_statement_screens',
    mg_securities_badges: 'mg_securities_badges',
    mg_prediction_graph_on_paywall: 'mg_prediction_graph_on_paywall',
    mg_body_age_first_screen: 'mg_body_age_first_screen',
};
